import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng/errorBoundary';
import AENewsSider from './aeNewsSider';
import AENews from './aeNews';

class AutoAndEnt extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { aeNewsSiderData, aeNewsData },
        } = this.props;

        return (
            <div className={styles.box}>
                <AENewsSider content={aeNewsSiderData} />
                <AENews content={aeNewsData} />
            </div>
        );
    }
}

export default errorBoundary(AutoAndEnt);
